import { Flex, Heading, Text, Img } from '@chakra-ui/react'
import { FC } from 'react'

import Layout from '@component/Layout'

const AcessDenied: FC = () => {
  return (
    <Layout title="Accesso Negado">
      <Flex
        flexDir="column"
        alignItems="center"
        justifyContent="center"
        bg="white"
        borderRadius="8px"
        h="calc(100vh - 128px)"
        p={8}
      >
        <Img
          src="https://cdn.dribbble.com/users/669537/screenshots/5821620/dribbble-clip800x600_2.gif"
          width={['30%', '30%', '20%']}
        ></Img>
        <Heading
          fontSize={['90px', '90px', '160x']}
          fontWeight="800"
          bgGradient="linear(40deg, #f9e900, #1d5840)"
          bgClip="text"
        >
          401
        </Heading>

        <Heading mb={8} fontWeight="400">
          Acesso Negado
        </Heading>
        <Text maxW="460px" textAlign="center">
          Não foi possível acessa essa página! Você não tem permissão contate o
          Administrador
        </Text>
      </Flex>
    </Layout>
  )
}

export default AcessDenied
